module.exports = __webpack_public_path__ + "static/media/logo_2x.a0864758.svg";